import React from 'react';
import PropTypes from 'prop-types';

import Input from '../Input';
import InputLabelWrapper from '../InputLabelWrapper';
import { useTheme } from '../../contextProviders';

const InputText = ({
  id,
  label,
  isSortable = false,
  sortDirection = 'none',
  onLabelClick = () => { },
  value = '',
  onChange,
  placeholder
}) => {
  const { isDarkMode } = useTheme();
  return (
    <InputLabelWrapper
      label={label}
      isSortable={isSortable}
      sortDirection={sortDirection}
      onLabelClick={onLabelClick}
      className={isDarkMode ? 'text-black' : 'text-white'}
    >
      <Input
        id={id}
        className={isDarkMode ? "!mt-2 bg-white text-blackDark" : "!mt-2 bg-white text-black"}
        type="text"
        containerClassName="mr-2"
        value={value}
        onChange={event => {
          onChange(event.target.value);
        }}
        placeholder={placeholder}
      />
    </InputLabelWrapper>
  );
};

InputText.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  isSortable: PropTypes.bool,
  sortDirection: PropTypes.oneOf(['ascending', 'descending', 'none']),
  onLabelClick: PropTypes.func,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};

export default InputText;
